<template>
  <nav aria-label="breadcrumb">
    <div class="row">
      <div class="col-lg-9 col-sm-9">
        <h6 class="mb-0 font-weight-bolder" :class="color">
          {{ currentPage }}
        </h6>
      </div>
      <div class="col-lg-3 col-sm-3">
        <material-button
          class="my-4 mb-2"
          variant="gradient"
          @click="createMerchant()"
          color="success"
          fullWidth
          data-bs-toggle="modal"
          data-bs-target="#addMerchantModal"
        >
          Add Merchant
        </material-button>
      </div>
    </div>
  </nav>

  <!-- Modal -->
  <div
    class="modal fade"
    id="addMerchantModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
    data-bs-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <!-- Loading Overlay -->
        <div v-if="isLoading" class="loading-overlay">
          <div class="loading-content">
            <div class="spinner-border text-success mb-3" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mb-2">Creating merchant...</p>
            <div class="progress" style="width: 250px; height: 6px">
              <div
                class="progress-bar progress-bar-striped progress-bar-animated bg-success"
                role="progressbar"
                :style="{ width: progressValue + '%' }"
                :aria-valuenow="progressValue"
                aria-valuemin="0"
                aria-valuemax="100"
              ></div>
            </div>
            <small class="text-muted mt-2"
              >Please wait... ({{ Math.round(progressValue) }}%)</small
            >
          </div>
        </div>

        <div class="modal-body p-0">
          <div class="card card-plain">
            <div class="card-header pb-0 text-left">
              <h5 class="">Add New Merchant</h5>
            </div>
            <div class="card-body pb-3">
              <form @submit.prevent="createMer">
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label"
                      >Code <i class="required">*</i></label
                    >
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <div class="input-group input-group-outline null">
                      <input
                        id="merchant_code"
                        placeholder="Enter Code"
                        type="text"
                        class="form-control"
                        v-model="form.merchant_code"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label"
                      >Merchant Name <i class="required">*</i></label
                    >
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <div class="input-group input-group-outline null">
                      <input
                        id="brand_name"
                        placeholder="Enter Merchant Name"
                        type="text"
                        class="form-control"
                        v-model="form.brand_name"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label">Logo</label>
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <div class="input-group">
                      <div class="custom-file" style="width: 100%">
                        <div class="input-group input-group-outline null">
                          <input
                            id="logo"
                            placeholder="Enter Merchant Name"
                            type="file"
                            class="form-control"
                            @change="handleFileUpload($event)"
                            :disabled="isLoading"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label">Parent Company ID</label>
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <select
                      id="parent_merchant_id"
                      class="form-select p-2"
                      v-model="form.parent_merchant_id"
                      :disabled="isLoading"
                    >
                      <option selected value="0">Open this select menu</option>
                      <option
                        v-for="merchant in dataListAllMerchant"
                        :key="merchant.id"
                        :value="merchant.id"
                      >
                        {{ merchant.brand_name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label">Company Email <i class="required">*</i></label>
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <div class="input-group input-group-outline null">
                      <input
                        id="company_email"
                        placeholder="Enter Company Email"
                        type="email"
                        class="form-control"
                        v-model="form.company_email"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label">Finance Email</label>
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <div class="input-group input-group-outline null">
                      <input
                        id="finance_email"
                        placeholder="Enter Finance Email"
                        type="email"
                        class="form-control"
                        v-model="form.finance_email"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label">Finance Mobile</label>
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <div class="input-group input-group-outline null">
                      <input
                        id="finance_mobile"
                        placeholder="Enter Finance Mobile"
                        type="text"
                        class="form-control"
                        v-model="form.finance_mobile"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>
                </div>
                <div class="row my-3">
                  <div class="col-lg-4 col-sm-4">
                    <label class="form-label">Refund Fee</label>
                  </div>
                  <div class="col-lg-8 col-sm-8">
                    <div class="input-group input-group-outline null">
                      <input
                        id="refund_fee"
                        placeholder="Enter Refund Fee"
                        type="number"
                        step="0.01"
                        min="0"
                        class="form-control"
                        v-model="form.refund_fee"
                        :disabled="isLoading"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <div class="row w-60">
            <div class="col-lg-6 col-sm-6 my-1">
              <material-button
                class="btn toast-btn btn-cancel"
                data-bs-dismiss="modal"
                variant="gradient"
                color="danger"
                fullWidth
                :disabled="isLoading"
              >
                Cancel
              </material-button>
            </div>
            <div class="col-lg-6 col-sm-6 my-1">
              <material-button
                class="btn toast-btn"
                variant="gradient"
                @click="createMer()"
                color="success"
                fullWidth
                :disabled="isLoading"
              >
                <span v-if="!isLoading">Create</span>
                <span v-else>
                  <span
                    class="spinner-border spinner-border-sm me-2"
                    role="status"
                    aria-hidden="true"
                  ></span>
                  Creating...
                </span>
              </material-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="position-fixed top-1 end-1 z-index-2 message-success">
      <material-snackbar
        v-if="snackbar === 'danger' || snackbar === 'success'"
        title=""
        date=""
        :description="message"
        :icon="{ component: 'campaign', color: 'white' }"
        :color="snackbar"
        :close-handler="closeSnackbar"
      />
    </div>
  </div>
</template>

<script>
import MaterialButton from "@/components/MaterialButton.vue";
import MerchantService from "../services/merchant.service";
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import { mapState } from "vuex";
import $ from "jquery";

export default {
  name: "breadcrumbs",
  components: {
    MaterialButton,
    MaterialSnackbar,
  },
  data() {
    return {
      form: {
        merchant_code: "",
        brand_name: "",
        logo: "",
        type: 0,
        parent_merchant_id: 0,
        status: 0,
        company_email: "",
        finance_email: "",
        finance_mobile: "",
        refund_fee: 0,
      },
      message: "",
      snackbar: null,
      isLoading: false,
      progressValue: 0,
      progressInterval: null,
      dataListAllMerchant: [],
    };
  },
  props: {
    currentPage: {
      type: String,
      required: "",
    },
    color: {
      type: String,
      default: "text-dark",
    },
  },
  computed: {
    ...mapState(["isRTL"]),
  },
  created() {
    this.getParentCompany();
  },
  beforeUnmount() {
    if (this.progressInterval) {
      clearInterval(this.progressInterval);
    }
  },
  methods: {
    handleFileUpload(event) {
      this.form.logo = event.target.files[0];
    },

    startProgress() {
      this.progressValue = 0;
      this.progressInterval = setInterval(() => {
        if (this.progressValue < 90) {
          const increment = this.progressValue < 50 ? 2 : 0.5;
          this.progressValue += increment;
        }
      }, 100);
    },

    completeProgress() {
      if (this.progressInterval) {
        clearInterval(this.progressInterval);
      }
      this.progressValue = 100;
      setTimeout(() => {
        this.progressValue = 0;
      }, 500);
    },

    createMer() {
      // Prevent double submission
      if (this.isLoading) return;

      this.isLoading = true;
      this.startProgress();

      let formData = new FormData();
      formData.append("merchant_code", this.form.merchant_code);
      formData.append("brand_name", this.form.brand_name);
      formData.append("logo", this.form.logo);
      formData.append("type", this.form.type);
      formData.append("parent_merchant_id", this.form.parent_merchant_id);
      formData.append("status", this.form.status);
      formData.append("company_email", this.form.company_email);
      formData.append("finance_email", this.form.finance_email);
      formData.append("finance_mobile", this.form.finance_mobile);
      formData.append("refund_fee", this.form.refund_fee || 0);

      MerchantService.createMerchant(formData).then(
        (response) => {
          console.log("response", response);
          this.completeProgress();

          if (response.data.result.isSuccess == false) {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.isLoading = false;
            this.setTimeOutNotification();
          } else {
            $(".btn-cancel").click();
            this.isLoading = false;
            window.location.href = "/admin/merchants?created=true";
          }
        },
        (error) => {
          console.log(error);
          this.completeProgress();
          this.snackbar = "danger";
          this.message =
            error.response?.data?.result?.message || "An error occurred";
          this.isLoading = false;
          this.setTimeOutNotification();
        }
      );
    },

    getParentCompany() {
      MerchantService.getAllMerchant().then(
        (response) => {
          this.dataListAllMerchant = response.data.data;
        },
        (error) => {
          console.log(error);
        }
      );
    },

    closeSnackbar() {
      this.snackbar = null;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>

<style scoped>
.required {
  color: red;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.95);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  border-radius: 0.5rem;
}

.loading-content {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.progress {
  border-radius: 1rem;
  overflow: hidden;
}

.progress-bar {
  transition: width 0.3s ease;
}
</style>
